import * as React from 'react';
import { GridColumnVisibilityModel } from '@mui/x-data-grid-pro';

import { EditColumnsDropdown } from './EditColumnsDropdown';
import { TableActionsDropdown } from './table-actions';
import { Export } from './table-actions/Export';

interface Props {
  columnVisibilityModel: GridColumnVisibilityModel;
  onColumnVisibilityChange: (newModel: Record<string, boolean>) => void;
}

export const ActionButtons: React.FC<Props> = ({
  columnVisibilityModel,
  onColumnVisibilityChange,
}) => {
  return (
    <div className="flex space-x-4">
      <EditColumnsDropdown
        columnVisibilityModel={columnVisibilityModel}
        onColumnVisibilityChange={onColumnVisibilityChange}
      />
      <TableActionsDropdown />
      <Export />
    </div>
  );
};
ActionButtons.displayName = 'TrackAndTrace.Controls.actions.ActionButton';
